import React, { createRef, useEffect, useState } from 'react';

import { ThemeProvider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { SnackbarProvider, closeSnackbar } from 'notistack';

import App from './App';
import theme from './theme';
import useBlocRef from './utils/useBlocRef.hook';

const useStyles = makeStyles(() => ({
  containerRoot: {
    width: '90%',
  },
}));

export default () => {
  const classes = useStyles();
  const blocRef = useBlocRef('snackbarAppBloc');
  const ref = createRef();
  const handleClick = (key) => () => {
    closeSnackbar(key);
  };

  const [appTheme, setAppTheme] = useState(theme);

  useEffect(() => {
    const themeSubscription = blocRef.current.theme$.subscribe(setAppTheme);
    return () => {
      themeSubscription.unsubscribe();
    };
  }, []);

  const handleAction = (key) => {
    return <Button onClick={handleClick(key)}>Dismiss</Button>;
  };

  return (
    <ThemeProvider theme={appTheme}>
      <SnackbarProvider
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        action={handleAction}
        classes={classes}
        ref={ref}
        autoHideDuration={6000}
        maxSnack={3}
        preventDuplicate>
        <App />
      </SnackbarProvider>
    </ThemeProvider>
  );
};
